import Aviso from '../../components/Aviso';
import { MuralInformativos } from '../../components/MuralInformativos';
import Footer from '../../components/Footer';
import NavBar from '../../components/NavBar';
import { EmptyState } from '../../components/EmptyState';
import { StatusAulaBadge } from '../../components/StatusAula';
import useAuth from '../../hooks/useAuth';
import { listarAulasPorAluno } from '../../services/api';
import { Avatar, Box, Flex, Skeleton, Stack, Table, TableCaption, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { FaChalkboardTeacher } from 'react-icons/fa';
import { useEffect, useState } from 'react';

interface AulaAluno {
	id: string;
    titulo : string;
    alunoId : string;
    materialId: string;
    professorId: string;
    data: string;
    status: string;
    professor: {
      nome: string;
      sobrenome: string;
      email: string;
      userId: string;
      avatarUrl: string;
    }
}

export default function Portal() {
	const { functionId } = useAuth();
	const [aulas, setAulas] = useState<AulaAluno[]>([]);
	const [loading, setLoading] = useState(true);

	// functionId (o id do aluno) ja foi resolvido pelo AuthContext no login e
	// cacheado; nao precisamos refazer buscarAlunoPorEmail so para obte-lo.
	useEffect(()=>{
		if (!functionId) return;
		listarAulasPorAluno(functionId).then((response)=>{
			setAulas(response.data);
			setLoading(false)
		});
	}, [functionId]);

	return (
		<>
			<NavBar />
			{/* minH, nao height: banner + lista passam de 85vh em telas baixas e, com altura
			    fixa, o conteudo vazava por cima do Footer. */}
			<Flex width={'100%'} minH={"85vh"} paddingBottom="50px" alignItems="center" bgColor="paper" overflowX="unset" flexDir="column">
				<Box width="90%" marginTop="50px">
					<MuralInformativos fallback={<Aviso />} />
				</Box>
				{
					loading ?
					<Flex width={'90%'} marginTop="50px">
						<Stack width="100%">
							<Skeleton height='40px' />
							<Skeleton height='40px' />
							<Skeleton height='40px' />
						</Stack>
					</Flex>
					:
			aulas.length === 0 ? (
			<Flex width={'90%'} justifyContent="center" marginTop="50px" backgroundColor="white" borderRadius="10px">
				<EmptyState
					icon={FaChalkboardTeacher}
					title="Nenhuma aula agendada"
					description="Quando o Windfall agendar suas próximas aulas, elas aparecem aqui."
				/>
			</Flex>
			) : (
			<TableContainer
				width={'90%'}
				height="fit-content"
				backgroundColor="white"
				borderRadius="10px"
				marginTop="50px"
			>
						<Table variant='simple'>
							<TableCaption>Próximas Aulas</TableCaption>
							<Thead>
							<Tr>
								<Th>Professor</Th>
								<Th>Assunto</Th>
								<Th>Data</Th>
								<Th>Status</Th>
							</Tr>
							</Thead>
							<Tbody>
								{aulas
								.sort((a, b) => {
									if (a.data > b.data) return -1;
									if (a.data < b.data) return 1;
									return 0;
								})
								.map((item, key)=>{
									return(
									<Tr key={key}>
										<Td>
											<Flex gap={"10px"} alignItems={"center"}>
												<Avatar
													size="sm"
													name={`${item.professor.nome} ${item.professor.sobrenome}`}
													src={item.professor.avatarUrl}
												/>
												{`${item.professor.nome} ${item.professor.sobrenome}`}
											</Flex>
										</Td>
										<Td>{item.titulo}</Td>
										<Td>{new Date(item.data).toLocaleString("pt-br", {
											day: "2-digit",
											month: "2-digit",
											year: "2-digit",
											hour:"2-digit",
											minute:"2-digit"
										  })}</Td>
										  <Td>
											<StatusAulaBadge status={item.status} />
										  </Td>
									</Tr>)
								})}
							</Tbody>
						</Table>
				</TableContainer>
				)
				}
			</Flex>
			<Footer />
		</>
	);
}
